import type { CellulaTheme } from '../../core/theme';
import { TokenOverrides } from './cellula_provider.component';

export interface CSSVariableModel {
	name: string;
	value: string;
}

export namespace ThemeBuilder {
	export function insertTokens(id: string, theme: CellulaTheme, providedInRoot: boolean, tokenOverrides?: TokenOverrides): void {
		const CSSVariables: CSSVariableModel[] = [];

		if (theme.tokens) {
			for (const key in theme.tokens) {
				const item = theme.tokens[key];
				if (tokenOverrides && tokenOverrides[key]) {
					item.value = tokenOverrides[key];
				}

				if (item.cssVar && item.value) {
					CSSVariables.push({
						name: item.cssVar,
						value: item.value,
					});
				}
			}
		}

		if (theme.components) {
			// todo: How to type this?! 🤔
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
			const components = theme.components as any;
			for (const component in components) {
				if (components[component]) {
					for (const property in components[component]) {
						CSSVariables.push({
							name: `--cellula-component-${component}-${property}`,
							value: components[component][property],
						});
					}
				}
			}
		}

		insertCSSVariables(id, CSSVariables, providedInRoot);
	}

	function insertCSSVariables(id: string, CSSVars: CSSVariableModel[], providedInRoot: boolean): void {
		const sheet = getStyleSheet(id);

		if (!sheet) {
			throw new Error("CellulaProvider: Can't find sheet element...");
		}

		const newCSSVariables = `
		${providedInRoot ? ':root' : `[data-cellula-id="${id}"]`} {
			${CSSVars.map((variable) => `${variable.name}: ${variable.value};`).join('\n')}
			}
`;

		for (let i = 0; i < sheet.cssRules.length; i++) {
			sheet.deleteRule(i);
		}

		sheet.insertRule(newCSSVariables, sheet.cssRules.length);
	}

	function getStyleSheet(id: string): CSSStyleSheet | null {
		let styleElement = document.getElementById(`cellula-theme-styles-${id}`) as HTMLStyleElement;
		if (!styleElement) {
			styleElement = createStyleElement(id);
		}

		return styleElement.sheet;
	}

	function createStyleElement(id: string): HTMLStyleElement {
		const styleElement = document.createElement('style');
		styleElement.id = `cellula-theme-styles-${id}`;
		styleElement.appendChild(document.createTextNode(''));
		styleElement.type = 'text/css';
		document.head.appendChild(styleElement);

		return styleElement;
	}
}
